// Ignore blank spacer paragraphs only before the article's first real content.
function removeLeadingArticleSpacers(root = document) {
  root.querySelectorAll('.article__content').forEach((content) => {
    let first = content.firstChild;

    while (first) {
      if (first.nodeType === Node.COMMENT_NODE ||
          (first.nodeType === Node.TEXT_NODE && !first.textContent.trim())) {
        first = first.nextSibling;
        continue;
      }

      if (first.nodeType !== Node.ELEMENT_NODE || first.tagName !== 'P' ||
          first.textContent.trim() ||
          first.querySelector(':not(span, br, strong, em, b, i, u, s, small, mark, sub, sup)')) {
        break;
      }

      const next = first.nextSibling;
      first.remove();
      first = next;
    }
  });
}

removeLeadingArticleSpacers();
document.addEventListener('shopify:section:load', (event) => {
  removeLeadingArticleSpacers(event.target);
});
